export enum TabsOrientationType {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum AccordionDefaultState {
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
}
